import React, { useState } from 'react';
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import {useForm} from "react-hook-form";
import {connect, useSelector} from "react-redux";

// labels

// actions

// components
import { ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";
import SelectGeneric from "../../../components/select/selectGeneric";
import {applicativeProvider} from "../../../providers/applicativeProvider";
import Moment from "moment";
import {utilHelper} from "../../../jwt/_helpers";
import {appRequestLogService} from "../../../jwt/_services/monitor/AppRequestLogService";
import {GenericButton} from "../../../components/buttons/customButtons";
import {getStateByPath} from "../../../redux/selectors";
import {setFilter} from "../../../redux/actions/generics/IndexedActions";


function AppRequestLogFilters(props) {
    // const { filter } = props.listProps

    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { filter } = componentState?.data;

    const [applicative, setApplicative] = useState(filter !== undefined && filter !== null ? filter?.applicative : null);
    const [resetValues, setResetValues] = useState(false);
    const [from, setFrom] = useState(utilHelper.formatDateToString(Moment().subtract(2, 'minutes').toDate(), 'YYYY-MM-DD HH:mm:ss') );
    const [to, setTo] = useState(utilHelper.formatDateToString(new Date(), 'YYYY-MM-DD HH:mm:ss') );

    const cleanFields = () => {
        setApplicative(null);
        setResetValues(!resetValues);
        reset();
    }

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            from: from,
            to: to
        }
    });

    const onSubmit = (data, _) => {
        // format dates to yyyy-MM-dd HH:mm:ss
        if( !data?.from || !data?.to ) {
            alert("Debe seleccionar un rango de fechas.");
            return;
        }

        const _dataFilter = {
            from: data.from ? new Moment(data.from).format('YYYY-MM-DD HH:mm:ss') : null,
            to: data.to ? new Moment(data.to).format('YYYY-MM-DD HH:mm:ss') : null
        };

        if (applicative !== undefined && applicative !== null && applicative !== '')
            _dataFilter.applicative = { id: applicative };

        props.setFilter(path, _dataFilter);
    };

    const onDepurate = () => {
        // Valida si filters tiene from y to
        if( !from || !to ) {
            alert("Debe seleccionar un rango de fechas para depurar los logs.");
            return;
        }

        appRequestLogService.depurate({
            from: from ? new Moment(from).format('YYYY-MM-DD  HH:mm:ss') : null,
            to: to ? new Moment(to).format('YYYY-MM-DD  HH:mm:ss') : null
        }).then( _ => {

        }).catch( e => {
            console.error("Error depurando logs", e);
        })
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="2">
                        <FormGroup>
                            <Label>Aplicación</Label>
                            <SelectGeneric
                                initialValue={ applicative }
                                setExternalValue = { value => setApplicative( value ) }
                                isDisabled = { false }
                                resetValue={ resetValues }
                                provider = { applicativeProvider }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{'Desde'}</Label>
                            <Input type="datetime-local"
                                   name="from"
                                   innerRef={register}
                                   value={from}
                                      onChange={ e => setFrom( e.target.value )  }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{'Hasta'}</Label>
                            <Input type="datetime-local"
                                   name="to"
                                   innerRef={register}
                                   value={to}
                                   onChange={ e => setTo( e.target.value )  }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            {/*<GenericButton*/}
                            {/*    style={'warning'}*/}
                            {/*    icon={'fa-undo'}*/}
                            {/*    toolTip={'Depurar logs antiguos'}*/}
                            {/*    label={'Depurar'}*/}
                            {/*    permission={'delete'}*/}
                            {/*    onClick={onDepurate}*/}
                            {/*/>*/}
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(AppRequestLogFilters)
